export const CustomSCStateConditions = Object.freeze({
  ATTENTION: 'toedit',
  CHECKED: 'applied',
  FOLLOWUP: 'followup',
  FOLLOWED: 'followed',
  THUMB_UP: 'accepted',
  THUMB_DOWN: 'refused',
  EXTERNALAPPLIED: 'externalapplied'
})

const CustomSCStateConditionText = (t, stateCondition) => {
  switch (stateCondition) {
    case CustomSCStateConditions.CHECKED:
      return t('favorites.label.status.checked')
    case CustomSCStateConditions.THUMB_UP:
      return t('favorites.label.status.thumb.up')
    case CustomSCStateConditions.FOLLOWUP:
      return t('favorites.label.status.followup')
    case CustomSCStateConditions.FOLLOWED:
      return t('favorites.label.status.followed')
    case CustomSCStateConditions.THUMB_DOWN:
      return t('favorites.label.status.thumb.down')
    case CustomSCStateConditions.EXTERNALAPPLIED:
      return t('favorites.label.status.externalapplied')
    default:
      return t('favorites.label.status.attention')
  }
}

export { CustomSCStateConditions as default, CustomSCStateConditionText }
